<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 시작, 종료 날짜 -->
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000999') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 유형 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000069')"
						paramKey="partClCd"
						@commChange="setSearchParam"
						:options="getPartClCdList_"
						:propData="searchParams.partClCd"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PqyTotStts/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			searchDateRange: []
		};
	},
	components: { SelectCombo },
	async created() {
		console.clear();
		this.screen = this.screenArray.get(this.scrId);
		await this.getCommCodes_({ key: 'partClCdList', codeType: 'PART_CL' }); //유형
		try {
			this.searchDateRange = [...this.getSearchMonths_];
			// await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}

			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed, ...qmsComputed },
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getPqyTotSttsList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
